<template>
    <div class="addtest">
        <div class="attachtest">
            <div class="attachtest_header">
                <div class="title">
                    Прикрепить тест
                </div>
                <div class="close">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14.3751 4.1665L9.99951 8.5415L5.62489 4.1665L4.16669 5.62484L8.5413 9.99984L4.16669 14.3748L5.62489 15.8332L9.99951 11.4582L14.3751 15.8332L15.8334 14.3748L11.4587 9.99984L15.8334 5.62484L14.3751 4.1665Z" fill="#ABABB2"/>
                    </svg>
                </div>
            </div>
            <div class="attachtest_main">
                <div class="search">
                    <input type="search" placeholder="Поиск по тестам">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>
    @import "../../../styles_fonts.scss";

    $font_Geometria: Geometria, 'Geometria';

.addtest{
    position: fixed;
    top: 0;
    left: 0;
    min-height: 100%;
    width: 100%;
    background: rgba(0, 0, 0, 0.39);
    display: flex;
    border: 0;
    justify-content: center;
    align-items: center;
    z-index: 10;
}
.attachtest{
    
    background: #FFFFFF;
    box-sizing: border-box;
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25), 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 12px;

    .attachtest_header{
        padding: 24px 40px 22px 40px;
        display: flex;
        background: #8C71FE;
        border-radius: 12px 12px 0px 0px;

        .title{
            font-family: $font_Geometria;
            font-style: normal;
            font-weight: bold;
            font-size: 22px;
            line-height: 120%;
            color: #FFFFFF;
        }
        .close{
            display: flex;
            align-items: center;
            padding-left:894px;
            cursor: pointer;
        }
    }
    .attachtest_main{
        padding: 40px;
    }
}
    
</style>